// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import { translate } from 'react-i18next';
import * as MessageHelper from 'app-lib/helpers/message-banner-helper';


export class MessageBanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: props.show
        };
    }
    componentWillReceiveProps() {
        this.setState({show: this.props.show});
    }
    close() {
        this.setState({show: false});
        // callback
        this.props.errorHandled(this.props.errorData.dataCall, this.props.errorData.errorCode);
    }

    // get Modal texts using MessageHelper
    getText() {
        return MessageHelper.getModalText(this.props.errorData);
    }
    render() {
        const styles = {
            body: {
                textAlign: 'center'
            },
            button: {
                width: '13%',
                backgroundColor: '#04b7db'
            },
            footer: {
                textAlign: 'right'
            }
        };
        const titleClass = classNames({
            error: this.props.type === 'error',
            info: this.props.type === 'info'
        });
        // if kind is true show error for featured
        return (
            <Modal dialogClassName="modal-container" show={this.state.show}>
                <Modal.Body style={styles.body}>
                    <h2 className={titleClass}>{this.getText().title}</h2>
                    <p dangerouslySetInnerHTML={this.getText().description}></p>
                </Modal.Body>
                <Modal.Footer style={styles.footer}>
                    <button className="btn btn-color-blue" style={styles.button} onClick={this.close.bind(this)}>OK</button>
                </Modal.Footer>
            </Modal>
      );
    }
}

MessageBanner.propTypes = {
    type: PropTypes.object,
    title: PropTypes.object,
    message: PropTypes.object,
    errorCode: PropTypes.object,
    show: PropTypes.Boolean,
    errorHandled: PropTypes.func,
    errorData: PropTypes.object,
    kind: PropTypes.object,
    t: PropTypes.func.isRequired
};


export default translate(['translation'])(MessageBanner);



// WEBPACK FOOTER //
// ./src/components/SharedComponents/messageBanner.js